import angular = require("angular");
import TPL = require("templates");
import Contracts = require("../../models/contracts");
import {ConfirmController} from "../../modals/confirm";
import {Covers} from "../../models/data";

import {Config} from "../../config";

export class ImageUploaderDirective {

  template = TPL.commonDirectives.imageUploader;
  scope = {
    params: "=params",
    current: "=current",
    image: "=image"
  };
  link;


  constructor(session, $modal, $timeout, $log) {
    this.link = (scope, el, attrs) => {
        scope.vm = {
          active: 0,
          lastValidUploadedImage: undefined,
          lastUploadedImage: undefined,
          isUploading: false,
          uploadCurrentPercentual: 0,
          covers: Covers.getCoversInstance(Config.publicEndpoint),
          onFileChange(invalidFilesArray, event) {
            $log.debug("onFileChange");
            $log.debug(invalidFilesArray);

            if (scope.vm.lastUploadedImage) {
              scope.vm.lastValidUploadedImage = scope.vm.lastUploadedImage;
              scope.vm.active = scope.vm.covers.length;
            }

            if (invalidFilesArray && invalidFilesArray.length && event && event.type == "change") {
              ConfirmController.openImageTooLargeModal($modal);
            }
          }
        }

        var getRandomInt = (min, max) => {
          return Math.floor(Math.random() * (max - min)) + min;
        }

        scope.vm.active = scope.current ? scope.vm.covers.length : getRandomInt(0, scope.vm.covers.length - 1);

        //TODO try to avoid uploading the same image twice
        scope.image = () => {

          for (var i = 0; i < scope.vm.covers.length; i++) { //1. user has selected a cover
            //returning meta for cover
            if (scope.vm.active >= 0 && scope.vm.active < scope.vm.covers.length) {
              return $timeout(()=>scope.vm.covers[scope.vm.active].url);
            }
          }


          if (!scope.vm.lastValidUploadedImage) {//2. user has selected the first but has uploaded nothing
            //returning null to update nothing
            return $timeout(false);
          }


          //3. user has uploaded an image

          scope.vm.isUploading = true;
          return session.uploadFile(scope.vm.lastValidUploadedImage,
            (progress) => {
              scope.vm.uploadCurrentPercentual = (progress.loaded / progress.total) * 100;
            }).then((result) => {
              scope.vm.isUploading = false;
              return result;
            });
        };
    }
  }

  static factory() {
    var tmp = (a, b, c, d) => new ImageUploaderDirective(a, b, c, d);
    tmp.$inject = ["session", "$uibModal", "$timeout", "$log"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/imageUploader.ts
 **/